---
title: "Co rząd odkrył za 10 mln zł — i co to oznacza dla Twojej instytucji"
description: "Raport AI-DC potwierdził: axe-core wykrywa tylko 30% błędów WCAG. Chatbot rządowy pojawi się w 2028. Kontrole PFRON nie czekają."
date: 2026-03-13
tags: [wcag, dostępność, ai-dc, prawo]
slug: "ai-dc-co-rzad-odkryl-za-10-mln-zl"
---

30% błędów WCAG — tyle wykrywa axe-core, najpopularniejsze darmowe narzędzie audytowe. Nie 70%. Nie 90%. Trzydzieści.

To nie nasze szacunki. To wynik projektu AI-DC — 10 479 700 PLN ze środków publicznych, zespoły SAGES i IPI PAN, grudzień 2025. Potwierdzenie tego, co widzimy w każdym z 18 własnych audytów.

Jeśli Twój informatyk "sprawdził stronę w axe-core i wyszło mu czysto" — na 70% błędów nadal czekają na odkrycie przez kontrolera.

---

## Co raport za 10 milionów zmierzył w sprawie WCAG

Badacze AI-DC przetestowali modele sztucznej inteligencji pod kątem automatycznej oceny dostępności stron. Wyniki są precyzyjne i w kilku miejscach zaskakujące.

Axe-core radzi sobie z prostymi błędami mechanicznymi: brakującym atrybutem `alt`, zduplikowanym ID, brakiem etykiety w formularzu. Kontekstu nie rozumie. Dlatego 70% naruszeń WCAG — tych, które wymagają interpretacji treści — po prostu nie widzi.

Kontrast kolorów to osobna pułapka. Modele językowe popełniają błąd przy pomiarze kontrastu w zakresie 30–80%. Raport AI-DC stwierdza wprost: kontrast musi liczyć algorytm — nie model językowy. Fakt, że AI wie co to "kontrast 4.5:1", nie znaczy, że potrafi go zmierzyć na zdjęciu ekranu.

Spośród wszystkich przetestowanych modeli, jedynie Gemini 2.5 Pro poprawnie analizował semantyczne naruszenia WCAG po polsku. Dla instytucji obsługujących polskojęzycznych użytkowników — to twarda granica automatyzacji.

Cytat z raportu: *"Nie istnieją gotowe rozwiązania out-of-the-box stworzone w tym celu. Połączenie narzędzi regułowych, statystycznych i ludzkiego mózgu ma ogromny potencjał do krzyżowego wykrywania błędów."*

Rekomendacja: hybryda axe-core + AI + ekspert. Nie samo narzędzie. Nie sam AI. Człowiek musi być w tym procesie — i to jest wniosek dokumentu za 10 milionów złotych.

{/* TODO: link-internal */}

---

## Dlaczego czekanie na 2028 rok to ryzyko

Projekt AI-DC planuje chatbota wspierającego instytucje publiczne w ocenie dostępności — termin: styczeń 2028.

Ustawa z 4 kwietnia 2019 r. o dostępności cyfrowej obowiązuje dziś. Art. 5 nakłada obowiązek zgodności z WCAG 2.2 poziom AA na wszystkie podmioty publiczne — bez wyjątku. Art. 10 wymaga aktualnej deklaracji dostępności. Art. 18 daje organom nadzoru uprawnienia do przeprowadzania kontroli i wydawania nakazów dostosowania.

Kontrole PFRON odbywają się teraz. Skargi obywateli kierowane na podstawie Art. 14 trafiają do organów nadzoru teraz. Deklaracja dostępności, której nie zaktualizowałeś od roku — narusza Art. 10 teraz.

Żaden chatbot nie sprawi, że wcześniejsze naruszenia znikną z protokołów kontrolnych.

---

## Jak wygląda błąd, którego axe-core nie zobaczy?

Strona urzędu gminy. Podstrona z ogłoszeniami — lista aktualności. Każdy wpis kończy się przyciskiem:

> **Kliknij tutaj**

Axe-core nie zgłosi błędu. Link ma tekst, ma cel, ma prawidłowy HTML. Narzędzie reguł jest zadowolone.

Osoba niewidoma używająca czytnika ekranu nawiguje inaczej — przesuwa się między linkami, słuchając ich nazw. Czytnik odczytuje kolejno: "Kliknij tutaj. Kliknij tutaj. Kliknij tutaj." Czternaście razy. Bez kontekstu. Bez informacji dokąd prowadzi każdy z tych linków.

To naruszenie WCAG 2.4.4 — "Cel linku (w kontekście)". Poziom A. Obowiązkowe. Wykrycie wymaga rozumienia treści i intencji, nie sprawdzenia kodu.

W 10 z 18 instytucji publicznych, które audytowaliśmy, ten typ błędu występował na co najmniej jednej podstronie. Axe-core nie wykrył go w żadnym z tych przypadków.

{/* TODO: link-internal */}

---

## Co w praktyce zmienia to dla Twojej instytucji

Raport automatyczny "0 błędów" to wyniki z 30% strony. Pozostałe 70% to przestrzeń, w której mogą żyć naruszenia poziomu A — te najpoważniejsze, blokujące dostęp użytkownikom z niepełnosprawnościami.

Deklaracja dostępności oparta wyłącznie na skanie automatycznym jest niepełna. Art. 10 ustawy wymaga, by odzwierciedlała rzeczywisty stan dostępności. Tak wygląda zdecydowana większość deklaracji polskich instytucji — i żadna z nich nie spełnia tego wymogu.

Błędy semantyczne są najczęstsze i najtrudniejsze do wychwycenia automatycznie. W 17 z 18 audytowanych instytucji publicznych zdjęcia nie miały poprawnych opisów alternatywnych — błąd WCAG 1.1.1, poziom A. W 16 z 18 przyciski lub linki nie miały dostępnych nazw — błąd WCAG 4.1.2. Oba typy axe-core wykrywa tylko częściowo, bo wynik zależy od kontekstu, nie od obecności atrybutu.

Ministerstwo Cyfryzacji wydało 10,5 mln PLN, żeby to zbadać i opisać. Wynik jest jednoznaczny: **pełny audyt wymaga człowieka.**

{/* TODO: link-internal */}

---

## Czy Twoja deklaracja dostępności jest dziś ważna?

Chatbot AI-DC, gdy powstanie, będzie narzędziem pomocniczym — dla instytucji, które chcą samodzielnie monitorować stan swoich stron. Nie zastąpi formalnego audytu. Nie cofnie wyników kontroli. Nie zaktualizuje deklaracji dostępności, która jest nieaktualna od trzech lat.

Sprawdź datę ostatniej aktualizacji deklaracji na swojej stronie. Jeśli przekracza 12 miesięcy — naruszasz Art. 10. Jeśli deklaracja nie zawiera procedury skargowej lub sekcji o dostępności nieobsługiwanej — naruszasz Art. 10. Nie hipotetycznie. Teraz.

---

[Bezpłatna konsultacja 15 minut — sprawdź ryzyko swojej instytucji →](https://bastunit.pl/kontakt)

---

*Dane z raportu AI-DC (SAGES + IPI PAN, grudzień 2025) dostępne na licencji CC BY 4.0. Statystyki błędów na podstawie 18 audytów instytucji publicznych przeprowadzonych przez BastunIT w latach 2025–2026.*
